import { Component } from '@angular/core';

@Component({
  selector: '[app-advertisement-footer]',
  templateUrl: './advertisement-footer.component.html',
  styleUrls: ['./advertisement-footer.component.css']
})
export class AdvertisementFooterComponent {

}
